/** Public list amounts shown in the app. Stripe Price IDs stay in Worker vars. */
export const publicListPricesUsd = {
  soloMonthly: 8,
  teamsSeatMonthly: 12,
  creditPack100: 5,
} as const;

export function teamsMonthlyUsd(seats: number): number {
  const bounded = Number.isFinite(seats) ? Math.max(2, Math.trunc(seats)) : 2;
  return bounded * publicListPricesUsd.teamsSeatMonthly;
}
